import * as React from 'react';
import { Tag } from '@grandvisionhq/common';
import { isString } from '@grandvisionhq/utils';
import { ProductReimbursableLogo } from '../../../../../ProductReimbursableLogo/ProductReimbursableLogo.js';

const ProductBlockHeaderLeft = ({ tag , isProductReimbursable , defaultReimbursableLogo , alternativeReimbursableLogo , reimbursableVariant ,  })=>{
    if (isProductReimbursable) {
        return /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
            defaultLogo: defaultReimbursableLogo,
            alternativeLogo: alternativeReimbursableLogo,
            variant: reimbursableVariant
        });
    }
    if (!tag || !isString(tag === null || tag === void 0 ? void 0 : tag.value)) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "v2-product-block-header-left"
    }, /*#__PURE__*/ React.createElement(Tag, {
        iconKey: tag === null || tag === void 0 ? void 0 : tag.key,
        label: tag.value
    }));
};

export { ProductBlockHeaderLeft };
//# sourceMappingURL=ProductBlockHeaderLeft.js.map
